import { Services } from '@sigma-frontend-libs/commons'
import { RECURRENT_PAYMENTS_METHODS } from '@sigma-legacy-libs/essentials/lib/constants'

import { components, labelModes } from '@/utils'

import selectorOwner from '@/components/selector/owner'
import paymentsMethod from '@/components/services/payments/method'

function renderSelectorOwner(h) {
  if (this.isPage) {
    return h(
      selectorOwner,
      {
        props: {
          value: this.proxy.OwnerId,
          labelMode: labelModes.hidden,
          dense: true
        },
        on: {
          input: event => {
            this.proxy.OwnerId = event
          }
        }
      }
    )
  }
}

function renderTypeSelect(h) {
  return h(
    components.select,
    {
      props: {
        value: this.proxy.type,
        label: this.getTranslate(`${Services.recurrentPayments}.labels.type`),
        items: this.types,
        labelMode: labelModes.hidden,
        dense: true,
        details: false,
        clearable: true
      },
      on: {
        input: event => {
          this.proxy.type = event
        }
      }
    }
  )
}

function renderStatusSelect(h) {
  return h(
    components.select,
    {
      props: {
        value: this.proxy.status,
        label: this.getTranslate(`${Services.recurrentPayments}.labels.status`),
        items: this.statuses,
        labelMode: labelModes.hidden,
        dense: true,
        details: false,
        clearable: true
      },
      on: {
        input: event => {
          this.proxy.status = event
        }
      }
    }
  )
}

function renderPaymentsMethod(h) {
  return h(
    paymentsMethod,
    {
      props: {
        OwnerId: this.OwnerId,
        value: this.proxy.method,
        items: RECURRENT_PAYMENTS_METHODS,
        dense: true,
        clearable: true
      },
      on: {
        input: event => {
          this.proxy.method = event
        }
      }
    }
  )
}

function renderButtons() {
  if (this.$scopedSlots.buttons) {
    return this.$scopedSlots.buttons()
  }

  return this.$slots.buttons
}

export default function(h) {
  return h(
    'div',
    {
      class: {
        [`${Services.recurrentPayments}-filter`]: true,
        [`${Services.recurrentPayments}-filter--admin`]: this.isPage && this.canGetUsers,
        [`${Services.recurrentPayments}-filter--users`]: !this.isPage && this.canCreateRecurrentPayments
      }
    },
    [
      renderSelectorOwner.call(this, h),
      renderTypeSelect.call(this, h),
      renderStatusSelect.call(this, h),
      renderPaymentsMethod.call(this, h),
      renderButtons.call(this)
    ]
  )
}
